module.exports = __webpack_public_path__ + "static/img/Bachelor_010812.24d5de4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010812.jpg
// module id = 255
// module chunks = 0